document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-menu-toggle]').forEach(button=>button.addEventListener('click',()=>{
    const menu=document.querySelector('[data-mobile-menu]');
    const isOpen=menu.hasAttribute('data-open');
    if(isOpen) menu.removeAttribute('data-open'); else menu.setAttribute('data-open','');
    button.setAttribute('aria-expanded',String(!isOpen));
  }));
  document.querySelectorAll('[data-quantity]').forEach(group=>{
    const input=group.querySelector('input');
    group.querySelectorAll('button').forEach(btn=>btn.addEventListener('click',()=>{
      const delta=btn.dataset.action==='plus'?1:-1;
      input.value=Math.max(1,Number(input.value||1)+delta);
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
  });
  const announcement=document.querySelector('[data-announcement]');
  if(announcement){
    const items=[...announcement.querySelectorAll('.announcement__item')];
    if(items.length>1){let i=0;setInterval(()=>{items[i].classList.remove('is-active');i=(i+1)%items.length;items[i].classList.add('is-active')},3500)}
  }
  document.querySelectorAll('[data-sticky-atc]').forEach(btn=>btn.addEventListener('click',()=>{
    const form=document.querySelector('#MainProductForm');
    if(form){const submit=form.querySelector('[type="submit"]'); if(submit) submit.click();}
  }));
});

// Zupy Motion Hero
(() => {
  const initMotionHero = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    const slides = [...root.querySelectorAll('[data-motion-slide]')];
    const dots = [...root.querySelectorAll('[data-motion-dot]')];
    if (slides.length < 2) return;
    root.dataset.motionReady = 'true';
    let current = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    let timer = null;
    const delay = Math.max(2500, Number(root.dataset.autoplay || 3000));
    const show = (index) => {
      slides[current]?.classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current]?.classList.add('is-active');
      dots[current]?.classList.add('is-active');
    };
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => { show(current + 1); schedule(); }, delay);
    };
    root.querySelector('[data-motion-next]')?.addEventListener('click', () => { show(current + 1); schedule(); });
    root.querySelector('[data-motion-prev]')?.addEventListener('click', () => { show(current - 1); schedule(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); schedule(); }));
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.addEventListener('mouseenter', () => clearTimeout(timer));
      root.addEventListener('mouseleave', schedule);
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearTimeout(timer); else schedule();
    });
    schedule();
  };
  const boot = () => document.querySelectorAll('[data-motion-hero]').forEach(initMotionHero);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll?.('[data-motion-hero]').forEach(initMotionHero));
})();

// Zupy Cart Drawer
(() => {
  const getDrawer = () => document.getElementById('CartDrawer');

  const setToggleState = (open) => {
    document.querySelectorAll('[data-cart-drawer-toggle]').forEach(btn => btn.setAttribute('aria-expanded', String(open)));
  };

  const openDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    setToggleState(true);
  };

  const closeDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    document.body.style.overflow = '';
    setToggleState(false);
  };

  const updateCartCount = (count) => {
    document.querySelectorAll('.cart-count').forEach(el => { el.textContent = count; });
  };

  const refreshDrawer = () => {
    if (!window.routes) return Promise.resolve();
    return fetch(`${window.routes.cartUrl}?section_id=cart-drawer`)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newDrawer = doc.getElementById('CartDrawer');
        const current = getDrawer();
        if (!newDrawer || !current) return;
        const wasOpen = current.hasAttribute('data-open');
        current.replaceWith(newDrawer);
        if (wasOpen) newDrawer.setAttribute('data-open', '');
      });
  };

  const changeLine = (line, quantity) => {
    if (!window.routes) return;
    fetch(window.routes.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0) })
    })
      .then(r => r.json())
      .then(cart => {
        updateCartCount(cart.item_count);
        return refreshDrawer();
      })
      .catch(() => {});
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-toggle]')) {
      e.preventDefault();
      openDrawer();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    const qtyBtn = e.target.closest('[data-cart-line-qty-btn]');
    if (qtyBtn) {
      e.preventDefault();
      const line = qtyBtn.dataset.line;
      const input = document.querySelector(`[data-cart-line-qty-input][data-line="${line}"]`);
      const next = Math.max(0, Number(input?.value || 1) + Number(qtyBtn.dataset.delta));
      changeLine(line, next);
      return;
    }
    const removeBtn = e.target.closest('[data-cart-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(removeBtn.dataset.line, 0);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-line-qty-input]');
    if (input) changeLine(input.dataset.line, input.value);
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !window.routes) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    const formData = new FormData(form);
    fetch(window.routes.cartAddUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          console.error(data.description || data.message);
          return;
        }
        return fetch(`${window.routes.cartUrl}.js`)
          .then(r => r.json())
          .then(cart => {
            updateCartCount(cart.item_count);
            return refreshDrawer();
          })
          .then(openDrawer);
      })
      .catch(() => {})
      .finally(() => { if (submitBtn) submitBtn.disabled = false; });
  });
})();
